__turbopack_context__.v({
  "container": "Asset-module__swzoAq__container",
  "image": "Asset-module__swzoAq__image",
  "link": "Asset-module__swzoAq__link",
});
